import React from 'react';
import { PickList } from 'primereact/picklist';
import  './pickListCustom.css';
import { ServicoAdicionalTemplate } from './TemplateServicoAdicional.jsx';
// eslint-disable-next-line import/no-unresolved
import Loading from './loading';

export default function PickListServicosAdicionais({ onChange, loading ,servicosAdicionais,setServicosAdicionais, setServicosAdicionaisSelecionados, servicosAdicionaisSelecionados }) {
    const render = loading? Loading : ServicoAdicionalTemplate;
    const source = loading? [{}] : servicosAdicionais;
    const target = loading? [{}] : servicosAdicionaisSelecionados;

    return (
        <PickList
            className='picklist'
            responsive
            showTargetControls={false}
            showSourceControls={false}
            onChange={onChange}
            source={source}
            target={target}
            itemTemplate={render}
            sourceHeader='Serviços disponíveis'
            targetHeader='Serviços selecionados'/>
    );
}
